/**
 * @internal
 * EmojiPane Style classes
 */
export interface EmojiPaneStyle {
    quickPicker: Object;
    tooltip: Object;
    emojiTextInput: Object;
    partialList: Object;
    fullListContent: Object;
    fullListBody: Object;
    fullList: Object;
    roosterEmojiPane: Object;
    emoji: Object;
    navBarButton: Object;
    navBarTooltip: Object;
    selected: Object;
    navBar: Object;
    statusBarDetails: Object;
    statusBarDetailsContainer: Object;
    statusBar: Object;
    statusBarIcon: Object;
    statusBarNoResultDetailsContainer: Object;
    emojiSelected: Object;
}
